export default __webpack_public_path__ + "static/cruiselines-vrc-ship-8-fe115839d04be8301ba3ee8dfe79fce2.jpg";